<template>
  <chat-history />

  <chat-input />
</template>

<script setup lang="ts">
import ChatHistory from "./chatHistory.vue";
import ChatInput from "./chatInput.vue";
</script>
